import { Modal } from "antd";
import Title from "antd/lib/typography/Title";
import { History } from "history";
import React, { useState } from "react";
import { Prompt } from "react-router-dom";

interface RCGProps {
    disablePrompt?: boolean,
    allowedNavPaths?: Array<string>,
    infoText: string,
    subInfoText: string,
    history: History
}

const RouteChangeGuard: React.FC<RCGProps> = ({ disablePrompt, allowedNavPaths = [], infoText, subInfoText, history }) => {
    const [targetLocation, setTargetLocation] = useState<any>();

    const handleBlockedNavigation = (nextLocation: any, targetLocation: string) => {
        if (allowedNavPaths?.includes(nextLocation.pathname) || disablePrompt) {
            return true;
        } else {
            if (targetLocation) return true;
            setTargetLocation(nextLocation);
            showConfirm(nextLocation);
            return false;
        }
    }

    const showConfirm = (targetLocation: any) => {
        Modal.confirm({
            keyboard: false,
            title: <Title style={{ fontSize: "20px" }}>{infoText}</Title>,
            icon: null,
            content: <span className="color-gray-5">{subInfoText}</span>,
            okText: "Stay",
            cancelText: "Leave",
            onOk: () => {
                setTargetLocation(undefined);
            },
            onCancel: () => {
                history.push(targetLocation);
            },
            style: { maxWidth: "350px" },
            cancelButtonProps: { className: "color-pink border-pink margin-right-xs" }
        });
    }

    return <Prompt
        when={!disablePrompt}
        message={(location) => handleBlockedNavigation(location, targetLocation)}
    />
}

export default RouteChangeGuard;